<template>
  <div class="card-custom go-curve cell small-12 medium-6 text-left">
    <div class="grid-x grid-margin-x">
      <div class="cell small-4">
        <img class="do-centering-object" :src="img" alt="">
      </div>
      <div class="cell auto">
        <h3>&#10097; {{ title }}</h3>
        <p>{{ brief }}</p>
      </div>
    </div>
    <router-link :to="{name: 'Service', params: {page: route}}" tag="button" class="c-1 button margin-top go-curve do-centering-object">
      {{ $t('service.more') }}</router-link>
  </div>
</template>

<script>
export default {
  name: 'Card',
  props: ['route', 'title', 'img', 'brief']
}
</script>

<style lang="scss" scoped>
.card-custom {
  padding: 24px 32px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  margin-top: 10px;
  p {
    text-indent: 1em;
  }
}
</style>

